import { Injectable } from '@angular/core';
import { BaseStoreRepository } from '@/store/base-store.repository';
import { emailTraceStateInitialState, EmailTraceStateProps, emailTraceStateStore } from '@/store/email-trace-state/email-trace-state.store';
import { select } from '@ngneat/elf';

@Injectable({
  providedIn: 'root',
})
export class EmailTraceRepository extends BaseStoreRepository<EmailTraceStateProps> {
  constructor() {
    super(emailTraceStateStore.pipe(select(state => state)), emailTraceStateStore, emailTraceStateInitialState);
  }
}
